export enum ProductActionTypes {
  SET_PRODUCTS = "SET_PRODUCTS",
  SET_PRODUCT_KEYS = "SET_PRODUCT_KEYS",
  SET_ASSIGNED_USERS = "SET_ASSIGNED_USERS",
  SET_AVAILABLE_PRODUCTS = "SET_AVAILABLE_PRODUCTS",
  SET_SUBSCRIPTIONS = "SET_SUBSCRIPTIONS",
  SET_SHOW_SUBSCRIPTIONDETAILS = "SET_SHOW_SUBSCRIPTIONDETAILS",
  SET_ADDONS_LIST = "SET_ADDONS_LIST",
}
